import { DetailedRecurrenceFrequency, type CareServiceCareVolumeDto } from '@pflegix/types';
import { getDetailedRecurrenceFrequency } from '@pflegix/util';
import { getLatestValidVolume } from './get-latest-valid-volume.util';

export interface IFrequencyFromVolumes {
  rhythm: DetailedRecurrenceFrequency;
  visits: number;
  duration: number;
}

const DEFAULT_FREQUENCY_FROM_VOLUMES: IFrequencyFromVolumes = {
  rhythm: DetailedRecurrenceFrequency.DAILY,
  visits: 1,
  duration: 1,
} as const;

/**
 * Calculates the frequency, visits, and duration from a list of volumes.
 *
 * @param volumes - The list of volumes to calculate the frequency from.
 * @returns An object containing the calculated frequency, visits, and duration.
 */
export function getFrequencyFromVolumes(volumes: CareServiceCareVolumeDto[] = []): IFrequencyFromVolumes {
  if (!volumes || !volumes.length) {
    return DEFAULT_FREQUENCY_FROM_VOLUMES;
  }

  const latestVolume = getLatestValidVolume(volumes);

  if (!latestVolume) {
    return DEFAULT_FREQUENCY_FROM_VOLUMES;
  }

  const { frequencyType, frequencyInterval } = latestVolume;

  return {
    rhythm:
      frequencyType && frequencyInterval
        ? getDetailedRecurrenceFrequency(frequencyType, frequencyInterval)
        : DEFAULT_FREQUENCY_FROM_VOLUMES.rhythm,
    visits: latestVolume.volumeIteration,
    duration: latestVolume.volumeDuration,
  };
}
